export default __webpack_public_path__ + "static/media/reiningL.889a994a.png";